import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import FormGroup from "./FormGroup"
import Divider from "./Divider"
import { TxlGhostButton } from "./TxlButton"
import { useDomainInfo } from "./DomainInfoProvider"
import AppleSignInButton from "./AppleSignInButton"
import { requestSocialLogin } from "../state/modules/login"

const SocialLoginForm = ({
  facebookButtonCaption,
  googleButtonCaption,
  socialLogin,
}) => {
  const { t } = useTranslation("generic")

  const { onCustomDomain } = useDomainInfo()

  const [showSocialLogins, setShowSocialLogins] = useState(true)

  useEffect(() => {
    setShowSocialLogins(!onCustomDomain)
  }, [onCustomDomain])

  return (
    <>
      {showSocialLogins && (
        <div>
          <FormGroup>
            <TxlGhostButton
              display="block"
              $primaryColor="#3b5998"
              onClick={() => socialLogin("facebook")}
            >
              {t("##.Auth.WithFacebook")}
            </TxlGhostButton>
          </FormGroup>
          <FormGroup>
            <TxlGhostButton
              display="block"
              $primaryColor="#d34836"
              onClick={() => socialLogin("google")}
            >
              {t("##.Auth.WithGoogle")}
            </TxlGhostButton>
          </FormGroup>
          <FormGroup>
            <AppleSignInButton />
          </FormGroup>
          <Divider label={t("##.Generic.Or")} />
        </div>
      )}
    </>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    socialLogin: serviceid => {
      dispatch(requestSocialLogin(serviceid))
    },
  }
}

export default connect(null, mapDispatchToProps)(SocialLoginForm)
